import axios from 'axios';
import Button from 'patternity/lib/button2';
import ModalDialog from 'patternity/lib/modal_dialog';
import SaveButton from 'patternity/lib/save-button';
import TextArea from 'patternity/lib/text_area';
import { identity, pathOr } from 'ramda';
import React from 'react';
import { withNamespaces } from 'react-i18next';
import { branch, compose, renderNothing, withHandlers, withProps, withState } from 'recompose';

const apiUrl = window._infl.api.url;
const defaultAdmins = pathOr([], ['_infl', 'settings', 'watercooler', 'default_admin_ids'], window);

const hubApi = window.jwt(axios.create({
  baseURL: apiUrl,
  headers: {
    'X_ORG_ID': window._infl.hub.id
  }
}), axios);

const enhance = compose(
  withNamespaces('HubFE'),
  branch(
    () => defaultAdmins.length > 0,
    identity,
    renderNothing
  ),
  withState('dialogOpen', 'setDialogOpen', false),
  withState('suggestionText', 'setSuggestionText', ''),
  withState('submitStatus', 'setSubmitStatus', 'unsaved'),
  withHandlers({
    submit: props => event => {
      if (props.submitStatus !== 'unsaved')
        return;

      const handleSuggestedSuccess = () => {
        props.setSubmitStatus('saved');
        app.analytics.logEvent(
          'ChallengeView::CHALLENGE_SUGGESTED'
        );
        setTimeout(() => props.setDialogOpen(false), 1000);
      };

      const handleSuggestedFailure = error => {
        props.setSubmitStatus('error');
        Honeybadger.notify(error, {
          message: error.message,
          name: 'Challenge suggestion messaging error',
          context: {
            requestConfig: error.config,
            response: error.response
          }
        });
      };

      const message = `Challenge suggestion:\n${props.suggestionText}`;
      props.setSubmitStatus('saving');

      const url = `${apiUrl}/conversations`;
      hubApi.get(url, { params: { person: defaultAdmins }})
        .then(({ data }) => {
          if (data.data.length === 1) {
            return hubApi.post(data.data[0].relationships.messages.links.related,
              { data: { attributes: { message } } })
          }
          else {
            return hubApi.post(url,
              { data: { attributes: { people: defaultAdmins, message } } })
          }
        })
        .then(handleSuggestedSuccess)
        .catch(handleSuggestedFailure);
    },
    toggleDialog: props => set => event => {
      if (window._infl.hub.features.includes('inbox_v2')) {
        window.location = "/chat?p=admin";
        return;
      }

      props.setSubmitStatus('unsaved');
      props.setSuggestionText('');
      props.setDialogOpen(set);
    },
    changeSuggestionText: props => event => {
      props.setSuggestionText(event.target.value)
    }
  }),
  withProps( ({ suggestionText, submitStatus, t }) => ({
    isDisabled: suggestionText.trim().length === 0,
    saveButtonText: {
      unsaved: t("That's my suggestion"),
      saving: t('Saving'),
      saved: t('Submitted'),
      error: t('Error')
    }
  }))
);

export default enhance(({ toggleDialog, dialogOpen, suggestionText, submit,
  isDisabled, changeSuggestionText, submitStatus, setDialogOpen, saveButtonText, t }) =>
  <span>
    <div className='challenge-suggestion' data-qa='challenge-suggestion-button'>
      <Button type='secondary' onClick={toggleDialog(true)}>{t('Suggest a Challenge')}</Button>
    </div>
    <ModalDialog isModalOpen={dialogOpen} size="medium" onClose={toggleDialog(false)}>
      <ModalDialog.Header title={t('Have a suggestion for a challenge?')} />
      <ModalDialog.Body>
        <div className='clearfix'>
          <label htmlFor="challenge-suggestion">{t('Suggest a challenge that speaks to your individual expertise or our advocate community')}</label>
          <TextArea
            id='challenge-suggestion'
            value={suggestionText}
            onChange={changeSuggestionText}
            style={{ height: '65px' }}
            name='challenge-suggestion'
            data-qa='challenge-suggestion-textarea'/>
          <div style={{ float: 'right' }} data-qa='challenge-suggestion-submit-button'>
            <SaveButton customText={saveButtonText}
              saveStatus={submitStatus}
              onClick={submit}
              disabled={isDisabled}/>
          </div>
        </div>
      </ModalDialog.Body>
    </ModalDialog>
  </span>
);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_suggestion/index.jsx